import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import isEmpty from 'lodash/isEmpty';
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField';
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm';
import InputField from '../../../../../FormControl/input/InputField';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilter, showFilter } from '../../../../../../store/actions/filter.actions';
import { updateSkip } from '../../../../../../store/actions/datatable.actions';

const FilterDialog = ({
  dataRoles = [],
  dataYears = [],
  errorFetchRoles,
  errorFetchYears,
  isLoadingRoles,
  isLoadingYears,
  module = ''
}) => {
  const date = useSelector((state) => state?.date?.date || new Date());
  const filter = useSelector((state) => state?.filter?.[module]?.filter || {});
  const open = useSelector((state) => state?.filter?.[module]?.open || false);

  const dispatch = useDispatch();

  const [form, setInputForm] = useState(filter);
  const [error, setInputError] = useState({});

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter);
    }
  }, [filter]);

  const onClose = () => {
    dispatch(showFilter(module, false));
  };

  const onChange = (name, value) => {
    if (name === 'rolesId') {
      setInputError({ ...error, [name]: null, roles: null });
      const roles = dataRoles.filter((item) => value.includes(item.id));
      setInputForm({ ...form, [name]: value, roles });
    } else if (name === 'yearLevelId') {
      setInputError({ ...error, [name]: null, yearLevel: null });
      const yearLevel = dataYears.filter((item) => value.includes(item._id));
      setInputForm({ ...form, [name]: value, yearLevel });
    } else {
      setInputForm({ ...form, [name]: value });
      setInputError({ ...error, [name]: null });
    }
  };

  const onApply = () => {
    const filter = {
      ...form
    };

    dispatch(updateFilter(module, filter));
    dispatch(showFilter(module, false));
  };

  return (
    <DialogConfirmCancel
      id='builder-user-filter'
      open={open}
      title='Filter'
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='flex flex-col gap-4'>
        <div className='grid grid-cols-3 items-center gap-4'>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Code
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-code'
              name='code'
              value={form.code}
              error={error.code}
              helperText={error.code}
              maxDate={date}
              onChange={(e) => onChange('code', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            first name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-first-name'
              name='firstName'
              value={form.firstName}
              error={error.firstName}
              helperText={error.firstName}
              maxDate={date}
              onChange={(e) => onChange('firstName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            last name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-last-name'
              name='lastName'
              value={form.lastName}
              error={error.lastName}
              helperText={error.lastName}
              maxDate={date}
              onChange={(e) => onChange('lastName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            preferred name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-preferred-name'
              name='preferredName'
              value={form.preferredName}
              error={error.preferredName}
              helperText={error.preferredName}
              onChange={(e) => onChange('preferredName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Roles
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleField
              id='form-filter-roles'
              name='rolesId'
              value={form.rolesId}
              error={error.rolesId || errorFetchRoles}
              helperText={error.rolesId || errorFetchRoles}
              onChange={(e) => onChange('rolesId', e.target.value)}
              loading={isLoadingRoles}
              options={dataRoles?.map((item) => ({ value: item.id, label: item.name })) || []}
              placeholder='Choose a role'
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            email
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-email'
              name='email'
              value={form.email}
              error={error.email}
              helperText={error.email}
              onChange={(e) => onChange('email', e.target.value)}
            />
          </div>
        </div>
      </Box>
    </DialogConfirmCancel>
  );
};

export default FilterDialog;
